export default {
  rabbit_zero_contract: {
    1: "0xE336E2503f2A6e3831468d0F16750EfdF6a92951", // Ethereum Mainnet
    4: "0x1AA9Fe28F11c1DCc002cbcCDB7e1df4c39A951b7", // Rinkeby Testnet
  },
  rabbit_one_contract: {
    1: "0xf846261B048E0BBe815fa8d26D621090E70A2f3C", // Ethereum Mainnet
    4: "0x84B21D62CEC20236A513BeF56C0F6deE3a973fDB", // Rinkeby Testnet
  },
  pfp_contract: {
    1: "0x1d2a1292bd92dea7be273592b5343aa35ff2eeda", // Ethereum Mainnet
    4: "0xd72c0fa911e87F4fA51E990c52b0ecFFb3DFa272", // Rinkeby Testnet
  },
  ukraine_contract: {
    1: "0x95d73d1c4EE20960ed919b46208d88209699414a", // Ethereum Mainnet
    4: "0xF61737a7Ef63b3fb55ACEe160192FA1Fe6D6b63D", // Rinkeby Testnet
  },
  access_contract: {
    1: "0x29e99baEfeaC4FE2b3dDDBBfC18A517fb7D6DDf8", // Ethereum Mainnet
    4: "0x64Ba170d3fd7302e64971395C7F7A07b53a33B3b", // Rinkeby Testnet
  },
  migrate: {
    1: "0xd9f17f18A63f4618d610c9727200bA6093Ddfb4C", // Ethereum Mainnet
    4: "0x0EAC275018eB44A7622E880b8De85DD9AC73C344", // Rinkeby Testnet
  },
};
